import { render, staticRenderFns } from "./goods-list.vue?vue&type=template&id=56385a6a&scoped=true&"
import script from "./goods-list.vue?vue&type=script&lang=ts&"
export * from "./goods-list.vue?vue&type=script&lang=ts&"
import style0 from "./goods-list.vue?vue&type=style&index=0&id=56385a6a&prod&lang=scss&"
import style1 from "./goods-list.vue?vue&type=style&index=1&id=56385a6a&prod&lang=scss&scoped=true&"
import style2 from "./goods-list.vue?vue&type=style&index=2&id=56385a6a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56385a6a",
  null
  
)

export default component.exports